import { styled } from "@mui/material";
import LinearProgress, {
	linearProgressClasses
} from "@mui/material/LinearProgress";

export const BorderLinearProgress = styled(LinearProgress)`
	position: relative;
	width: 9.174em;
	height: 1.5em;
	border-radius: 26px;
	background-color: transparent;
	& .${linearProgressClasses.bar} {
		border-radius: 26px;
		background-image: linear-gradient(
			180deg,
			#ffe179 0%,
			#ffc56d 30.73%,
			#ffb800 43.75%,
			#ff8100 100%
		);
	}

	&.completed {
		& .${linearProgressClasses.bar} {
			border-radius: 26px;
			background-image: linear-gradient(
				180deg,
				#888888 0%,
				#777777 30.73%,
				#666666 43.75%,
				#555555 100%
			);
		}
	}
`;

export const Container = styled("div")`
	position: absolute;
	bottom: 0.95em;
	left: 6.5em;
`;

export const TextContainer = styled("div")`
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	min-width: 6.6em;
	top: 0em;
	right: 0.2em;
	line-height: 1.5em;

	font-family: Baloo;
	font-style: normal;
	font-size: 1.1em;
	//text-shadow: 0.08em 0.08em 0em #000;
	-webkit-text-stroke-width: 0.15em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
`;
export const Text = styled("div")`
	display: flex;
	justify-content: center;
	width: 60%;
`;

export const Counter = styled("div")`
	display: flex;
	justify-content: center;
	width: 40%;
`;

export const Box = styled("img")`
	position: absolute;
	top: -0.6em;
	left: -1.4em;
	width: 3em;
`;
